import React from 'react';
import { Link } from 'react-router-dom';

type TextLinkProps = {
  /** Internal route path, or an absolute URL when `external`. */
  to: string;
  external?: boolean;
  className?: string;
  children: React.ReactNode;
};

/**
 * A real anchor, so links can be opened in a new tab, copied, and crawled.
 * Internal destinations go through the router; external ones are plain
 * anchors carrying the usual `noopener` protection.
 */
const TextLink: React.FC<TextLinkProps> = ({
  to,
  external = false,
  className = 'text-link',
  children,
}) => {
  if (external) {
    return (
      <a
        className={className}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={to}>
      {children}
    </Link>
  );
};

export default TextLink;
